import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a52d7bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-text" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "value", "placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "suggestions suggestions-action cursor-pointer flex flex-wrap justify-center mt-1"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dummy" }, "Dummy", -1))
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "mr-2"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createElementVNode("input", _mergeProps({
      type: "text",
      class: "border-2",
      ref: "input",
      id: _ctx.id,
      value: _ctx.value
    }, _ctx.$attrs, {
      placeholder: _ctx.placeholder,
      onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (_ctx.suggestions && _ctx.suggest(_ctx.suggestionsFiltered[0])), ["exact","prevent"]), ["tab"])),
      onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('end')), ["enter"])),
      onInput: _cache[2] || (_cache[2] = ev => _ctx.$emit('update:value', ev?.target?.value))
    }), null, 16, _hoisted_3),
    (_ctx.suggestions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestionsFiltered.slice(0, 7), (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["suggestion mr-2 text-sm", {first: !i}]),
              key: i,
              onClick: ($event: any) => (_ctx.$emit('update:value', item.value))
            }, _toDisplayString(item.name), 11, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}